import React from 'react';
import { x } from '@xstyled/styled-components';
import { t } from 'ttag';
import { select } from '~/lib/select';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Flex } from '~/ui/flex/Flex';
import { PickList } from '~/ui/pick-list/PickList';
import { TrainingState, useTrainingStore } from '../../state';
import { Legend } from '../Header';
import { SettingsPages, useSettingsStore } from '../Store';
import { playbackSpeeds, smallplaybackSpeeds } from './playbackSpeeds';

const selector = (s: TrainingState) =>
  select(s, 'playbackSpeed', 'setPlaybackSpeed', 'fasterPlaybackSpeed');

export const PlaybackSpeed = () => {
  const { playbackSpeed, setPlaybackSpeed, fasterPlaybackSpeed } =
    useTrainingStore(selector);
  const { page, setPage } = useSettingsStore();
  if (page !== SettingsPages.Speed) return null;

  const playbackSpeedList = fasterPlaybackSpeed
    ? playbackSpeeds
    : smallplaybackSpeeds;

  return (
    <>
      <CloseButton onClick={() => setPage(SettingsPages.Root)} />
      <Flex variant="list">
        <x.fieldset p={0} m={0}>
          <Legend>{t`Playback Speed`}</Legend>
          <PickList
            items={playbackSpeedList}
            selected={playbackSpeedList.find(ps => ps.speed === playbackSpeed)}
            valueField="speed"
            labelField="label"
            onSelect={item => {
              setPlaybackSpeed(item.speed);
              setPage(SettingsPages.Root);
            }}
          />
        </x.fieldset>
      </Flex>
    </>
  );
};
